import { createSuppliersExportRecord } from 'app/main/contacts/suppliers/createSuppliersExportRecord';
import { useParamsFromQueryContext } from 'framework/hooks/useParamsFromQueryContext';
import { onResetToPage1 } from 'framework/types/onResetToPage1';
import { useLocalization } from 'localization/useLocalization';
import React, { useEffect, useMemo, useState } from 'react';
import { SelectableColumn } from '../SelectableColumn';
import { QuickFilter } from '../SupplierAccountsListPage';
import { createColumnRecord } from '../utils/createColumnRecord';
import { createHeaders } from '../utils/createHeaders';
import { createQfRecord } from '../utils/createQfRecord';
import { QueryContext } from './QueryContext';
import { ViewContext } from './ViewContext';

const DefaultColumns: SelectableColumn[] = ['identifier', 'outstandingBalance', 'countPurchases'];

export const ViewProvider = ({ children }: any) => {
	const strings = useLocalization();
	const [qf, setQf] = useState<QuickFilter>('all');
	const [columns, setColumns] = useState<SelectableColumn[]>(DefaultColumns);
	const colRecord = useMemo(() => createColumnRecord(strings), [strings]);
	const headers = useMemo(() => createHeaders(colRecord, strings), [colRecord, strings]);
	const quickFilterRecord = useMemo(() => createQfRecord(strings), [strings]);
	const suppliersExportRecord = useMemo(() => createSuppliersExportRecord(strings), [strings]);
	const { setParams } = useParamsFromQueryContext(QueryContext);

	useEffect(() => {
		setParams(params =>
			onResetToPage1({
				...params,
				hasOutstandingBalance: qf === 'withOutstandingBalance' ? true : undefined,
			})
		);
		// eslint-disable-next-line
	}, [qf]);

	return (
		<ViewContext.Provider
			value={{
				columns: columns,
				columnsRecord: colRecord,
				headers: headers,
				setColumns: setColumns,
				quickFilter: qf,
				setQuickFilter: setQf,
				quickFilterRecord: quickFilterRecord,
				exportRecord: suppliersExportRecord,
			}}>
			{children}
		</ViewContext.Provider>
	);
};
